import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

const formatDay = (isoDate) => {
  const d = new Date(isoDate);
  if (isNaN(d)) return isoDate;
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
};

const QrPerformanceChart = ({ dailyTotals = [], topQRCodes = [] }) => {
  const maxTop = Math.max(...topQRCodes.map(q => q.totalAcessos), 1);
  const maxDaily = Math.max(...dailyTotals.map(day => Number(day.total) || 0), 1);
  const yAxisMaximum = Math.ceil(maxDaily);
  const yAxisTicks = [...new Set([0, Math.ceil(yAxisMaximum / 2), yAxisMaximum])];

  return (
    <div className="qr-performance">
      <div className="qr-performance-chart">
        <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
          <AreaChart data={dailyTotals} margin={{ top: 8, right: 20, left: -12, bottom: 0 }}>
            <defs>
              <linearGradient id="perfGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#5F6E4A" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#5F6E4A" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border-light)" vertical={false} />
            <XAxis dataKey="date" tickFormatter={formatDay} stroke="var(--text-light)" interval="preserveStartEnd" minTickGap={24} tickLine={false} axisLine={false} />
            <YAxis
              stroke="var(--text-light)"
              tickLine={false}
              axisLine={false}
              allowDecimals={false}
              allowDataOverflow
              domain={[0, yAxisMaximum]}
              ticks={yAxisTicks}
            />
            <Tooltip
              labelFormatter={formatDay}
              formatter={(value) => [value, 'Acessos']}
              contentStyle={{ borderRadius: 8, borderColor: 'var(--border-color)', fontSize: '0.9em' }}
            />
            <Area
              type="linear"
              dataKey="total"
              isAnimationActive={false}
              stroke="#5F6E4A"
              strokeWidth={2}
              fill="url(#perfGradient)"
              baseValue={0}
              activeDot={{ r: 4, fill: '#5F6E4A', stroke: '#fff', strokeWidth: 2 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="qr-performance-ranking">
        <h3><TrendingUp size={14} strokeWidth={2} /> Melhores QR Codes</h3>
        {topQRCodes.length === 0 ? (
          <p className="qr-performance-empty">Sem acessos registrados ainda.</p>
        ) : (
          <ul>
            {topQRCodes.map((qr) => (
              <li key={qr.qrId}>
                <span className="qr-performance-name" title={qr.nome || qr.qrId}>{qr.nome || qr.qrId}</span>
                <div className="qr-performance-bar-row">
                  <span className="qr-performance-bar-track">
                    <span
                      className="qr-performance-bar-fill"
                      style={{ width: `${(qr.totalAcessos / maxTop) * 100}%` }}
                    />
                  </span>
                  <span className="qr-performance-value">{qr.totalAcessos}</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default QrPerformanceChart;
